import { useState, useEffect } from 'react';
import { Box, Typography, Grid, alpha, Collapse, useTheme, Alert } from '@mui/material';
import parser from 'html-react-parser';

interface IAnnualMileageCalculatorProps {
	miles: number;
	helperText?: string;
	id: string;
}

type MileageRange = {
	min: number;
	max: number;
};

const AnnualMileageCalculator = ({ miles, helperText, id }: IAnnualMileageCalculatorProps) => {
	const theme = useTheme();

	const bkgColor = theme.palette.secondary.main;

	const open = Boolean(miles && !Number.isNaN(miles) && typeof miles === 'number');
	const [dailyMiles, setDailyMiles] = useState<MileageRange>({
		min: 0,
		max: 0,
	});
	const [weeklyMiles, setWeeklyMileage] = useState<MileageRange>({
		min: 0,
		max: 0,
	});

	useEffect(() => {
		if (open) {
			setWeeklyMileage({
				min: Math.round((miles - 1000) / 52),
				max: Math.round(miles / 52),
			});
			setDailyMiles({
				min: Math.round((miles - 1000) / 365),
				max: Math.round(miles / 365),
			});
		}
	}, [miles, open]);

	return (
		<Collapse in={open} easing='easing' orientation='vertical'>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					textAlign: 'center',
					alignItems: 'center',
					maxWidth: 'sm',
					margin: 'auto',
				}}
			>
				<Grid
					sx={{
						padding: '16px',
						border: `1px solid ${theme.palette.annualMileageFont.main}`,
						borderRadius: '4px',
						backgroundColor: alpha(bkgColor, 0.3),
						color: 'black',
						width: '100%',
					}}
				>
					<Typography variant='body1' sx={{ mb: '16px' }}>
						On average this is approximately
					</Typography>
					<Grid container justifyContent='center'>
						<Grid size={6} sx={{ borderRight: '1px solid grey' }}>
							<Typography variant='h6' sx={{ fontWeight: 'bold', height: '22px' }}>
								{`${dailyMiles.min} - ${dailyMiles.max}`}
							</Typography>
							<Typography variant='subtitle1'>miles a day</Typography>
						</Grid>
						<Grid size={6}>
							<Typography variant='h6' sx={{ fontWeight: 'bold', height: '22px' }}>
								{`${weeklyMiles.min} - ${weeklyMiles.max}`}
							</Typography>
							<Typography variant='subtitle1'>miles a week</Typography>
						</Grid>
					</Grid>
				</Grid>

				{helperText && (
					<Alert
						severity='info'
						sx={() => ({
							color: 'black',
							borderRadius: '4px',
							marginRight: 'auto',
							textAlign: 'left',
							mt: 2,
							width: '100%',
						})}
						id={`${id || ''}-helper-text`}
					>
						{parser(helperText)}
					</Alert>
				)}
			</Box>
		</Collapse>
	);
};
export default AnnualMileageCalculator;
